<div class="ticket-card p-3" [routerLink]="['/PKOFF', ticket.code]" role="button">

  <div class="ticket-card-title-band">
    <span class="ticket-no">{{ 'HOME.TICKET_NO_PREFIX' | translate }}{{ ticket.code }}</span>
    @if (ticket.status === 'Active' && isSettledTicket()) {
      <span class="ticket-status-pill status-settled">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="16" height="16" rx="8" fill="#0F9918" />
          <path
            d="M6.86343 10.6673C6.70335 10.6673 6.55128 10.6078 6.43922 10.5036L4.17409 8.39781C3.94197 8.18203 3.94197 7.82486 4.17409 7.60907C4.4062 7.39328 4.79039 7.39328 5.02251 7.60907L6.86343 9.3205L10.9775 5.49583C11.2096 5.28004 11.5938 5.28004 11.8259 5.49583C12.058 5.71161 12.058 6.06878 11.8259 6.28457L7.28764 10.5036C7.17559 10.6078 7.02351 10.6673 6.86343 10.6673Z"
            fill="white" />
        </svg>
        {{ 'HOME.TICKET_STATUS_SETTLED' | translate }}
      </span>
    }
  </div>

    <div class="ticket-time-row">
      <div class="ticket-time-block">
        <span class="ticket-time">{{ ticket.startTime | timeFormat }}</span>
        <span class="ticket-date">{{ ticket.startTime | dateFormat }}</span>
      </div>
      <div class="ticket-duration-connector">
        <span class="connector-dot"></span>
        <span class="connector-line"></span>
        @if (ticket.status !== 'Active' || isSettledTicket()) {
          <span class="connector-label">{{ getDurationHours(ticket.startTime, ticket.endTime) }}</span>
        }
        <span class="connector-line"></span>
        <span class="connector-dot"></span>
      </div>
      <div class="ticket-time-block ticket-time-block--end">
        <span class="ticket-time">{{ ticket.endTime | timeFormat }}</span>
        <span class="ticket-date">{{ ticket.endTime | dateFormat }}</span>
      </div>
    </div>

  <div class="ticket-perforated-divider">
    <span class="cutout cutout--left"></span>
    <span class="dashed-line"></span>
    <span class="cutout cutout--right"></span>
  </div>

  <div class="ticket-card-body">
    <div class="ticket-location">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 13.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
          stroke="#161616" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12 21C12 21 4 15.5 4 9.5a8 8 0 1 1 16 0C20 15.5 12 21 12 21Z" stroke="#161616" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span>
        {{ publicService.getCurrentLang() === 'en' ? ticket.parkingArea.englishName :
        ticket.parkingArea.arabicName }}
      </span>
    </div>
    <div class="ticket-footer">
      @if (ticket.status === 'Active' && !isSettledTicket()) {
          <app-countdown-timer mode="countup" [startTime]="ticket.startTime"></app-countdown-timer>
      } @else {
        <div class="ticket-amount" [class.ticket-amount--zero]="isZeroAmount(ticket.pricing?.total?.amount)">
          <app-riyal-symbol class="ticket-riyal-symbol"></app-riyal-symbol>
          <span>{{ ticket.pricing?.total?.amount ?? 0 | number:'1.2-2' }}</span>
        </div>
      }
      <span class="ticket-status-pill ms-auto" [ngClass]="getStatusPillClass(ticket.status)">
        @if (shouldShowStatusCheck(ticket.status)) {
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="16" height="16" rx="8" fill="#0F9918" />
            <path
              d="M6.86343 10.6673C6.70335 10.6673 6.55128 10.6078 6.43922 10.5036L4.17409 8.39781C3.94197 8.18203 3.94197 7.82486 4.17409 7.60907C4.4062 7.39328 4.79039 7.39328 5.02251 7.60907L6.86343 9.3205L10.9775 5.49583C11.2096 5.28004 11.5938 5.28004 11.8259 5.49583C12.058 5.71161 12.058 6.06878 11.8259 6.28457L7.28764 10.5036C7.17559 10.6078 7.02351 10.6673 6.86343 10.6673Z"
              fill="white" />
          </svg>
        }
        {{ getStatusTranslationKey(ticket.status) | translate }}
      </span>
    </div>
  </div>

</div>
